import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';
import { newCopiaStore } from '../newCopia.store';
import DashboardList from '../../../components/dashboardComponents/dashboardList';
import OopsComponent from '../../../components/oops';
import styles from './styles.module.scss';
import filterStore from '../../../components/CustomFilter/filter.store';
import cn from 'classnames';

const CopiaCategory = observer(() => {
  const { cards, fullScreenMap } = newCopiaStore;
  const { isLoading } = filterStore;
  const [searchParams] = useSearchParams();

  return (
    <div
      className={cn(styles.CopiaCategory, {
        [styles.mapMode]: fullScreenMap,
      })}
    >
      {!cards.length && !isLoading && (
        <div className="flex4">
          <OopsComponent
            title="Oops!"
            desc="There is no space with this name."
          />
        </div>
      )}
      <DashboardList listModeActive={searchParams.has('listModeActive')} />
    </div>
  );
});
export default CopiaCategory;
